import {useState, useEffect} from "react";
import {LayoutChild} from "../../../../../palette/Palette";
import PlacesReservation from "./Places";

function DirectionRoutes(props) {

    const {
        setDataCoords, dataCoords, DataStore, setRouteControl, routesControl, setShowCalendar, setClickControl
    } = props;


    const [addressOrigen, setAddressOrigen] = useState('')
    const [addressDestination, setAddressDestination] = useState('')


    useEffect(() => {
        if (addressOrigen !== '') {
            setAddressOrigen(dataCoords.origenDirection)
        }
        if (addressDestination !== '') {
            setAddressDestination(dataCoords.destinationDirection)
        }
    }, [dataCoords])

    return (
        <>
            <LayoutChild top={5}>

                <PlacesReservation placeholder={'Origen'} keyData={'origen'} setDataCoords={setDataCoords}
                                   dataCoords={dataCoords} DataStore={DataStore} setRouteControl={setRouteControl}
                                   routesControl={routesControl} setClickControl={setClickControl}
                                   setShowCalendar={setShowCalendar}
                                   setAddress={setAddressOrigen} address={addressOrigen}/>
            </LayoutChild>
            <LayoutChild top={5}>
                <PlacesReservation placeholder={'Destino'} keyData={'destiny'} setDataCoords={setDataCoords}
                                   dataCoords={dataCoords} DataStore={DataStore} setRouteControl={setRouteControl}
                                   routesControl={routesControl} setClickControl={setClickControl}
                                   setShowCalendar={setShowCalendar}
                                   setAddress={setAddressDestination} address={addressDestination}/>
            </LayoutChild>
        </>
    )
}


export default DirectionRoutes